<template>
  <v-container fluid>
    <v-row>
      <v-col class="text-h3 gray--text">
        Receitas de óculos
      </v-col>
    </v-row>

    <v-row
      dense
      v-for="(glassesPrescription, index) in glassesPrescriptionsPatient"
      :key="glassesPrescription.id"
    >
      <v-col>
        <GlassPresciptionListItem
          :glassesPrescription="glassesPrescription"
          :index="index"
          :allowEdit="false"
          :allowDelete="false"
          :forcePrint="true"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import GlassPresciptionListItem from "@/components/glasses_prescription/list/item.vue";

  export default {
    name: "MedicalCertificates",
    props: {
      patient: Object,
    },
    components: {
      GlassPresciptionListItem,
    },
    apollo: {
      glassesPrescriptionsPatient: {
        query: require("@/graphql/glasses_prescription/glasses_prescriptions_patient.gql"),
        variables() {
          return {
            patientId: this.patient.id,
          };
        },
        pollInterval: 20000,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
